import React from 'react';
import PropTypes from 'prop-types';
import { useObserver } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';
import { Grid, Button } from '@material-ui/core';

import { Label } from 'core/components/label';

const VinDiscrepancy = ({ classes, vinDiscrepancies }) => {
  const { offer: store } = useStore();

  const onClick = () => {
    store.triggerOfferDialog(false);
    store.clearVinDiscrepancies();
  };

  return useObserver(() => (
    <>
      <Label type="titleSecondary" className={classes.title}>
        One or more of the cars was not added to the policy
      </Label>
      <Label type="infoInnerTitle" className={classes.content}>
        Please be advised that the following vehicles were NOT added to the policy, likely because either the VIN is
        incorrect, we do not write the VIN, we do not have the VIN in our system yet, or because this is a state that
        has a vehicles:drivers ratio and these vehicles would result in too many cars being added to the policy:
      </Label>

      {vinDiscrepancies.map((discrepancy) => (
        <Label key={discrepancy.VIN} type="infoCardAlert" className={classes.content}>
          VIN: {discrepancy.VIN}
        </Label>
      ))}

      <Grid container alignItems="center" className={classes.bottom}>
        <Button onClick={onClick} variant="contained" color="primary" className={classes.btn}>
          <Label className={classes.btnLabel}>I acknowledge this</Label>
        </Button>
      </Grid>
    </>
  ));
};

VinDiscrepancy.propTypes = {
  classes: PropTypes.object.isRequired,
  vinDiscrepancies: PropTypes.array.isRequired
};

export default VinDiscrepancy;
